import axios from "axios";

export const client = axios.create({
    headers: {
        'Content-Type': 'application/json',//; charset=utf-8
        'Content-Encoding': 'identity'
    },
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_ENDPOINT
})

client.interceptors.request.use(
    (config) => {
        // const token = localStorage.getItem('RM-token');
        // if (token) {
        //     config.headers.Authorization = `Bearer ${token}`;
        // }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
)

client.interceptors.response.use(
    (config) => {
        return config;
    },
    async (error) => {
        const originalRequest = error.config
        if (error.response.status === 401 && !error.config._isRetry) {
            originalRequest._isRetry = true
            const accessToken = await refreshToken();
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            return client.request(originalRequest);
        }
        return Promise.reject(error);
    }
)


const refreshToken = async () => {
    const refreshToken = localStorage.getItem("RM-refresh");

    try {
        const refreshResp = await client.post(`api/auth/refresh`, {refreshToken})

        if (refreshResp.status === 200) {
            localStorage.setItem('RM-token', refreshResp.data.accessToken);
            localStorage.setItem('RM-refresh', refreshResp.data.refreshToken);
            return refreshResp.data.accessToken;
        }
        if (refreshResp.status === 400) {
            localStorage.removeItem('RM-token');
            localStorage.removeItem('RM-refresh');
            window.location.href = `/`
        }

    } catch (e) {
        localStorage.removeItem('RM-token');
        localStorage.removeItem('RM-refresh');
        window.location.href = `/login`
    }
}


